import { compose, prop } from 'ramda';

export default compose(Boolean, prop('id'));
